(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    /*
   * A/B test: product header placement.
   *
   * 1. Tag the block immediately following #breadcrumbs-container as #product-header.
   *    content_for 'blocks' renders that block as opaque HTML, so we give it a stable
   *    id client-side.
   *
   * 2. Variant (body.ab-product-header-top) — on mobile only, relocate #product-header
   *    to sit directly after .breadcrumbs-mobile-wrapper so the order becomes:
   *    breadcrumbs -> product header -> media gallery -> rest of product details.
   *    The element is nested deep inside .product-details, so this can't be done with
   *    CSS order alone (different containers); we move the node and let DY-injected CSS
   *    position it. A comment placeholder records the original position so desktop /
   *    variant-off layouts are restored untouched.
   *
   * 3. Dynamic Yield injects the variant class after the SDK loads (post-paint), so a
   *    MutationObserver on <body> re-runs apply() when the class lands. The anti-flicker
   *    mask (html.ab-ph-pending, see ab-product-header-antiflicker) stays up until DY has
   *    decided, so there is no control->variant flash:
   *      - variant: revealed the moment the move runs;
   *      - control: revealed when DY.Experience.ready resolves (no class will ever arrive),
   *        after a short grace so a near-simultaneous variant class wins and moves first;
   *      - last resort (no JS / DY blocked): the pure-CSS timeout in the snippet reveals it.
   */
  (function () {
    var VARIANT_CLASS = 'ab-product-header-top';
    var PENDING_CLASS = 'ab-ph-pending';
    var mobile = window.matchMedia('(max-width: 1079px)');
    var placeholder = null;

    function tagProductHeader() {
      var breadcrumbs = document.getElementById('breadcrumbs-container');
      if (!breadcrumbs) return;

      var next = breadcrumbs.nextElementSibling;
      if (next && next.id !== 'product-header') {
        next.id = 'product-header';
      }
    }

    function moveToMobile() {
      var header = document.getElementById('product-header');
      var wrapper = document.querySelector('.breadcrumbs-mobile-wrapper');
      if (!header || !wrapper || header.previousElementSibling === wrapper) return;

      if (!placeholder) {
        placeholder = document.createComment('product-header-anchor');
        header.parentNode.insertBefore(placeholder, header);
      }
      wrapper.insertAdjacentElement('afterend', header);
    }

    function restore() {
      var header = document.getElementById('product-header');
      if (!header || !placeholder || !placeholder.parentNode) return;
      if (header.previousSibling === placeholder) return;

      placeholder.parentNode.insertBefore(header, placeholder);
    }

    function reveal() {
      document.documentElement.classList.remove(PENDING_CLASS);
    }

    function apply() {
      if (document.body.classList.contains(VARIANT_CLASS) && mobile.matches) {
        moveToMobile();
        reveal();
      } else {
        restore();
        // Nothing is masked on desktop (mask CSS is mobile-only), so reveal immediately.
        if (!mobile.matches) reveal();
      }
    }

    function revealForControl() {
      // Grace period lets a variant class that lands right after DY responds win and
      // move first, so control reveal never causes a flash before the variant applies.
      setTimeout(function () {
        if (!document.body.classList.contains(VARIANT_CLASS)) reveal();
      }, 250);
    }

    function init() {
      tagProductHeader();
      apply();

      // DY injects the variant class after the SDK loads (post-paint).
      var observer = new MutationObserver(apply);
      observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

      // Reveal as soon as DY has responded (covers control, where no class arrives).
      var experience = window.DY && window.DY.Experience;
      if (experience && experience.ready && typeof experience.ready.then === 'function') {
        experience.ready.then(revealForControl);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    mobile.addEventListener('change', apply);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-info"] && !Shopify.designMode) return;
  try {
    (function () {
    const hoursElements = document.querySelectorAll('.contact-info__hours-status[data-hours]');

    hoursElements.forEach((element) => {
      const hoursText = element.dataset.hours;
      const isOpen = checkIfOpen(hoursText);
      element.dataset.open = isOpen;
    });

    function checkIfOpen(hoursText) {
      try {
        // Get current time in EST
        const now = new Date();
        const estTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
        const currentDay = estTime.getDay(); // 0 = Sunday, 1 = Monday, etc.
        const currentHour = estTime.getHours();
        const currentMinutes = estTime.getMinutes();
        const currentTimeInMinutes = currentHour * 60 + currentMinutes;

        // Parse hours string like "Monday - Friday 10AM - 6PM EST"
        const lines = hoursText.split(/\n|<br\s*\/?>/i);

        for (const line of lines) {
          const trimmedLine = line.trim();
          if (!trimmedLine) continue;

          // Match pattern: "Day - Day HH:MM AM/PM - HH:MM AM/PM" or "Day HH:MM AM/PM - HH:MM AM/PM"
          const dayRangeMatch = trimmedLine.match(
            /(\w+)\s*-\s*(\w+)\s+(\d{1,2})(?::(\d{2}))?\s*(AM|PM)\s*-\s*(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i,
          );
          const singleDayMatch = trimmedLine.match(
            /^(\w+)\s+(\d{1,2})(?::(\d{2}))?\s*(AM|PM)\s*-\s*(\d{1,2})(?::(\d{2}))?\s*(AM|PM)/i,
          );

          if (dayRangeMatch) {
            const [, startDay, endDay, openHour, openMin, openPeriod, closeHour, closeMin, closePeriod] = dayRangeMatch;
            const startDayNum = getDayNumber(startDay);
            const endDayNum = getDayNumber(endDay);

            if (isDayInRange(currentDay, startDayNum, endDayNum)) {
              const openTime = parseTime(parseInt(openHour), parseInt(openMin || 0), openPeriod);
              const closeTime = parseTime(parseInt(closeHour), parseInt(closeMin || 0), closePeriod);

              if (currentTimeInMinutes >= openTime && currentTimeInMinutes < closeTime) {
                return true;
              }
            }
          } else if (singleDayMatch) {
            const [, day, openHour, openMin, openPeriod, closeHour, closeMin, closePeriod] = singleDayMatch;
            const dayNum = getDayNumber(day);

            if (currentDay === dayNum) {
              const openTime = parseTime(parseInt(openHour), parseInt(openMin || 0), openPeriod);
              const closeTime = parseTime(parseInt(closeHour), parseInt(closeMin || 0), closePeriod);

              if (currentTimeInMinutes >= openTime && currentTimeInMinutes < closeTime) {
                return true;
              }
            }
          }
        }

        return false;
      } catch (e) {
        console.error('Error parsing hours:', e);
        return false;
      }
    }

    function getDayNumber(dayName) {
      const days = {
        sunday: 0,
        sun: 0,
        monday: 1,
        mon: 1,
        tuesday: 2,
        tue: 2,
        tues: 2,
        wednesday: 3,
        wed: 3,
        thursday: 4,
        thu: 4,
        thur: 4,
        thurs: 4,
        friday: 5,
        fri: 5,
        saturday: 6,
        sat: 6,
      };
      return days[dayName.toLowerCase()] ?? -1;
    }

    function isDayInRange(currentDay, startDay, endDay) {
      if (startDay <= endDay) {
        return currentDay >= startDay && currentDay <= endDay;
      } else {
        // Wraps around week (e.g., Friday - Monday)
        return currentDay >= startDay || currentDay <= endDay;
      }
    }

    function parseTime(hour, minutes, period) {
      let h = hour;
      if (period.toUpperCase() === 'PM' && hour !== 12) {
        h += 12;
      } else if (period.toUpperCase() === 'AM' && hour === 12) {
        h = 0;
      }
      return h * 60 + minutes;
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
